import { useTranslations } from "next-intl";
import { Button, Image } from "@components/core";

function UnlockEarlyGuide({ close, startAnimation }) {
  const t = useTranslations("common");

  return [
    <div className="drawer-body bg-white p-4" key="drawer-how-to-unlock-early-body">
      <div className="p-2 text-center">
        <h5 className="mb-2">{t("drawer.modal_how_to_unlock_early.how_to_unlock_early")}</h5>
        <p className="mb-3 text-gray">{t("drawer.modal_how_to_unlock_early.need_a_new_closet")}</p>
      </div>

      <div style={{ width: "80px"}} className="mx-auto">
        <Image
          src="unlockedBagNature"
          alt="unlocked-bag"
          className="w-100"
        />
      </div>

      <div className="py-4 m-2">
        <div className="d-flex flex-column gap-4 mb-0 px-2">
          <div className="font-weight-bold">
            <p className="mb-1">{t("drawer.modal_how_to_unlock_early.return_your_closet")}</p>
            <p className="font-weight-normal mb-0 text-gray">{t("drawer.modal_how_to_unlock_early.place_unpurchased_items_in_the_reusable_pouch")}</p>
          </div>
          <div className="font-weight-bold">
            <p className="mb-1">{t("drawer.modal_how_to_unlock_early.unlock_early")}</p>
            <p className="font-weight-normal mb-0 text-gray">{t("drawer.modal_how_to_unlock_early.go_here_and_click_on_unlock_early")}</p>
          </div>
          <div className="font-weight-bold">
            <p className="mb-1">{t("drawer.modal_how_to_unlock_early.confirm_to_unlock")}</p>
            <p className="font-weight-normal mb-0 text-gray">{t("drawer.modal_how_to_unlock_early.confirm_to_advance_your_next_due_date")}</p>
          </div>
        </div>
      </div>

      <div className="d-flex flex-column justify-content-center pt-3">
        <p className="mb-0 text-center text-gray">{t("drawer.modal_how_to_unlock_early.have_you_already_returned_your_closet")}</p>
        <Button
          variant="link-primary"
          className="mt-1 no-underline"
          onClick={startAnimation}
          trackingName="drawerReceived_unlockEarlyGuide_CheckMyReturn"
        >
          {t("drawer.modal_how_to_unlock_early.check_my_parcel")}
        </Button>
      </div>
    </div>,

    <div className="p-3 border-top bg-white" key="drawer-how-to-unlock-early-footer">
      <Button
        fullWidth
        onClick={close}
      >
        {t("drawer.modal_how_to_unlock_early.i_understand")}
      </Button>
    </div>,
  ];
};

export default UnlockEarlyGuide;
